<template>
  <header id="header" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-sm menu align-self-center">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <router-link class="nav-link" to="/competencies">Оценочные материалы</router-link>
            </li>


            <li class="nav-item">
              <router-link class="nav-link" to="/archive">Архив</router-link>
            </li>

          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 col-md-4">
          <router-link to="/">
            <img class="logo" src="/images/irpo_logo_white.svg" alt="logo">
          </router-link>
        </div>

        <div class="col-2 burger-menu col-md-1">
          <svg class="burger-menu__icon" @click="showMenu = !showMenu">
            <use xlink:href="#burger"></use>
          </svg>
        </div>

        <div class="col-sm main-title">
          <div class="header-text">
            ОЦЕНОЧНЫЕ МАТЕРИАЛЫ
            ДЛЯ ДЕМОНСТРАЦИОННОГО ЭКЗАМЕНА
          </div>
        </div>
      </div>

      <div class="row global-search">
        <div class="col-sm">
          <div class="header-search">
            <div class="search-label">Поиск по материалам</div>
            <div class="search-wrapper">
              <vue-simple-suggest
                ref="suggest"
                v-model="query"
                :list="list"
                :debounce="300"
                value-attribute="guid"
                @input="onInput"
                @select="onSuggestSelect">
                <input type="text" placeholder="Введите поисковой запрос" class="form-control search-input" @keyup.enter="search">

                <div class="suggestion-documents" >
                  <div
                    v-for="document of popularDocs"
                    :key="document.guid"
                    class="document"
                    @click="onSuggestSelect(document)"
                    v-text="document.parent.title">
                  </div>
                </div>

                <div slot="suggestion-item" slot-scope="{ suggestion, query }">
                  <div class="item-title">{{ suggestion.type === 'training-center' ?  suggestion.description : suggestion.title  }}</div>
                  <div v-if="suggestion.type" class="category">{{ typeMap[suggestion.type] }}</div>
                </div>

              </vue-simple-suggest>

              <button class="btn btn-search" @click="search">Найти</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-mobile-menu v-show="showMenu" @close="showMenu = false"></app-mobile-menu>

  </header>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import { AppMobileMenu } from "@/components";
import { typeMap, searchMixin } from "@/utils/helpers";
import { loadPupularDocs } from "@/api";
import "vue-simple-suggest/dist/styles.css";

export default {
  name: "Header",
  components: { AppMobileMenu, VueSimpleSuggest },
  mixins: [searchMixin],
  data: () => ({
    showMenu: false,
    query: "",
    list: [],
    popularDocs: [],
    typeMap
  }),
  watch: {
    $route() {
      this.showMenu = false;
    }
  },
  async created() {
    this.popularDocs = await loadPupularDocs();
  }
};
</script>

<style scoped lang="scss">
.container-fluid {
  background-image: url(/images/header-bg-home.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50px;
  padding-bottom: 61px;
  max-width: 2560px;
}

.menu {
  margin-bottom: 60px;

  .nav-link {
    border-bottom: 2px solid transparent;
  }
}

.main-title,
.menu {
  padding-left: 0;
}

.global-search {
  margin-top: 90px;
}

.header-search {
  display: flex;
  flex-wrap: wrap;

  .search-label {
    color: #fff;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 16px;
  }

  .search-label {
    flex: 0 0 100%;
  }

  .search-input {
    flex: 1;
    margin-right: 20px;
    padding-left: 30px;
    border-radius: 5px;
    border-style: unset;
  }

  .search-wrapper {
    display: flex;
    width: 100%;
    position: relative;
  }
}

.logo {
  height: 156px;
}

.header-text {
  color: #fff;
  font-size: $headings-font-size;
  line-height: $headings-line-height;
  font-weight: bold;
}

.burger-menu {
  position: absolute;
  top: 29px;
  right: 12px;
}

.suggestion-documents {
  display: flex;
  margin-top: 10px;

  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 5px;

  &::-webkit-scrollbar {
    display: none;
  }

  @include media-breakpoint-only(xs) {
    width: calc(100vw - 125px);
  }

  .document {
    font-size: 12px;
    line-height: 28px;
    color: #fff;
    border-radius: 5px;
    background-color: #6d9ae8;
    padding-left: 10px;
    padding-right: 10px;
    margin-right: 5px;
    text-decoration: none;
    flex: 0 0 auto;
    cursor: pointer;
  }
}

@include media-breakpoint-down(sm) {
  .container-fluid {
    padding-top: 35px;

    .container {
      padding-left: 22px;
      padding-right: 22px;
    }
  }
  .menu {
    display: none;
  }
  .main-title {
    padding-left: 15px;

    .header-text {
      padding-right: 40px;
    }
  }

  .global-search {
    margin-top: 50px;
  }

  #header {
    padding-left: 0;
    padding-right: 0;
  }

  .header-text {
    font-size: 20px;
    line-height: 23px;
    margin-top: 40px;
  }

  .logo {
    height: 80px;
  }

  .header-search {
    .btn {
      width: 86px;
      padding: 13px 10px;
      font-size: 18px;
      line-height: 21px;
      height: 58px;
      z-index: 9;
    }

    .search-input {
      margin-right: -5px;
      padding-left: 20px;
    }

    .search-label {
      font-size: 14px;
      line-height: 16px;
    }

    .search-input::-webkit-input-placeholder {
      font-size: 14px;
    }
  }
}

@include media-breakpoint-down(md) {
  .menu {
    display: none;
  }
}

@include media-breakpoint-up(lg) {
  .burger-menu {
    display: none;
  }
}

@include media-breakpoint-only(sm) {
  .container-fluid {
    .container {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
